
import ScanImg from '@/assets/scan.png'
import CHeader from '@/components/Header'
import TransMap from '@/components/TransMap'
import {
scanQRCode
} from '@utils/wechat'
import Search from 'vux/src/components/search/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Timeline from 'vux/src/components/timeline/timeline.vue'
import TimelineItem from 'vux/src/components/timeline/timeline-item.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

export default {
name: 'GoodsTracking',
components: {
CHeader,
TransMap,
Search,
Cell,
XInput,
XButton,
Group,
Timeline,
TimelineItem,
Flexbox,
FlexboxItem,
Popup
},
data () {
return {
scan_type: 1,
ScanImg: ScanImg,
WAYBILL: '',
ASNArr: [],
color: 'red',
order: null,
mapShow: false,
mapParams: null,
flowPass: false
}
},
created () {
this.WAYBILL = this.$route.query.WAYBILL
if (this.WAYBILL) this.onSubmit()
},
methods: {
openScan () {
let _this = this
scanQRCode(_this.scan_type).then(res => {
console.log('scan result', res)
if(res.indexOf(',')!='-1'){
res=res.split(',')[1]
}
if(!(/^[A-Za-z]{3}/).test(res)){
_this.$toast.warn('您扫码结果为'+res+' 扫码识别不成功，请重新扫码')
return;
};
_this.ASNArr.push(res)
_this.WAYBILL = _this.ASNArr.join(',')
_this.onSubmit()
})
},
toGoodsMap () {
var mapParams = {
STATUS: this.order.STATUS,
TRUCK_GUID: this.order.GUID,
CODE_103: this.order.RDC,
CODE_102: this.order.RECEIVINGPLACE
}
this.$router.push({
path: './tracking_map?params=' + encodeURIComponent(JSON.stringify(mapParams))
})
},
toPH () {
this.$router.push({
path: '/Asn?ASN=' + this.WAYBILL
})
},
toTH () {







this.$router.push({
path: `./thd?ID=${this.order.TH_ID}&WORKNO=${this.order.TH_WORKNO}`
})




},
toSH () {
this.$router.push({
path: `./psd?ID=${this.order.TRANS_ID}&WORKNO=${this.order.TRANS_WORKNO}`
})










},
onSubmit () {
let _this = this
if (!this.WAYBILL || this.WAYBILL.length < 8) {
_this.$toast.text('请录入索引单号')
return
}
_this.$vux.loading.show()
let url = 'Truck.ashx?action=Form_Load'
this.$post(url, {
WAYBILL: this.WAYBILL
}).then(
response => {

const order = response[0]
_this.order = order
if(_this.order.TH_WORKNO){
_this.toTH(1)

}else if(_this.order.TRANS_WORKNO){
_this.toSH(2)

}else{
_this.toPH()
}
_this.flowPass = [10, 11].indexOf(_this.order.STATUS) !== -1
_this.$vux.loading.hide()
}
).catch(
response => {
_this.$vux.loading.hide()
}
)
}
}
}



// WEBPACK FOOTER //
// ./src/pages/sctsnew/GoodsTracking.vue